/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The JobApplicationRequest model module.
 * @module model/JobApplicationRequest
 * @version 0.0.2
 */
class JobApplicationRequest {
    /**
     * Constructs a new <code>JobApplicationRequest</code>.
     * @alias module:model/JobApplicationRequest
     * @param fullName {String} Applicant's full name
     * @param email {String} Applicant's email address
     * @param resumeFile {String} Base64-encoded contents of the resume file
     * @param resumeFilename {String} Original resume filename, used to derive the file extension
     */
    constructor(fullName, email, resumeFile, resumeFilename) { 
        
        JobApplicationRequest.initialize(this, fullName, email, resumeFile, resumeFilename);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, fullName, email, resumeFile, resumeFilename) { 
        obj['full_name'] = fullName;
        obj['email'] = email;
        obj['resume_file'] = resumeFile;
        obj['resume_filename'] = resumeFilename;
        obj['cover_letter'] = '';
    }

    /**
     * Constructs a <code>JobApplicationRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobApplicationRequest} obj Optional instance to populate.
     * @return {module:model/JobApplicationRequest} The populated <code>JobApplicationRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobApplicationRequest();

            if (data.hasOwnProperty('full_name')) {
                obj['full_name'] = ApiClient.convertToType(data['full_name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('resume_file')) {
                obj['resume_file'] = ApiClient.convertToType(data['resume_file'], 'String');
            }
            if (data.hasOwnProperty('resume_filename')) {
                obj['resume_filename'] = ApiClient.convertToType(data['resume_filename'], 'String');
            }
            if (data.hasOwnProperty('cover_letter')) {
                obj['cover_letter'] = ApiClient.convertToType(data['cover_letter'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobApplicationRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobApplicationRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of JobApplicationRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['full_name'] && !(typeof data['full_name'] === 'string' || data['full_name'] instanceof String)) {
            throw new Error("Expected the field `full_name` to be a primitive type in the JSON string but got " + data['full_name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['resume_file'] && !(typeof data['resume_file'] === 'string' || data['resume_file'] instanceof String)) {
            throw new Error("Expected the field `resume_file` to be a primitive type in the JSON string but got " + data['resume_file']);
        }
        // ensure the json data is a string
        if (data['resume_filename'] && !(typeof data['resume_filename'] === 'string' || data['resume_filename'] instanceof String)) {
            throw new Error("Expected the field `resume_filename` to be a primitive type in the JSON string but got " + data['resume_filename']);
        }
        // ensure the json data is a string
        if (data['cover_letter'] && !(typeof data['cover_letter'] === 'string' || data['cover_letter'] instanceof String)) {
            throw new Error("Expected the field `cover_letter` to be a primitive type in the JSON string but got " + data['cover_letter']);
        }

        return true;
    }


}

JobApplicationRequest.RequiredProperties = ["full_name", "email", "resume_file", "resume_filename"];

/**
 * Applicant's full name
 * @member {String} full_name
 */
JobApplicationRequest.prototype['full_name'] = undefined;

/**
 * Applicant's email address
 * @member {String} email
 */
JobApplicationRequest.prototype['email'] = undefined;

/**
 * Base64-encoded contents of the resume file
 * @member {String} resume_file
 */
JobApplicationRequest.prototype['resume_file'] = undefined;

/**
 * Original resume filename, used to derive the file extension
 * @member {String} resume_filename
 */
JobApplicationRequest.prototype['resume_filename'] = undefined;

/**
 * Optional cover letter message
 * @member {String} cover_letter
 * @default ''
 */
JobApplicationRequest.prototype['cover_letter'] = '';






export default JobApplicationRequest;

